export enum DeviceType {
  MOBILE = 'Mobile',
  TABLET = 'Tablet',
  DESKTOP = 'Desktop',
}

export const isTouchableDevice = (): boolean => {
  try {
    document.createEvent('TouchEvent');

    return true;
  } catch (e) {
    return false;
  }
};

export const getTypeOfDevice = (): DeviceType => {
  const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  if (isTouchableDevice()) {
    if ((width <= 650 && height <= 900) || (width <= 900 && height <= 650)) {
      return DeviceType.MOBILE;
    }

    return DeviceType.TABLET;
  }

  return DeviceType.DESKTOP;
};
